import { lazy, Suspense } from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import { HomeProvider } from "../Context/ContextHome";
import { LoginProvider } from "../Context/ContextLogin";
import { AdminProvider } from "../Context/ContextAdmin";
import { ElevatoriaProvider } from "../Context/contextElevatoria";

const Login = lazy(() =>
  import("../Pages/Login").then((module) => ({ default: module.Login }))
);
const Home = lazy(() =>
  import("../Pages/Home").then((module) => ({ default: module.Home }))
);
const EEE = lazy(() =>
  import("../Pages/EEE").then((module) => ({ default: module.EEE }))
);
const MapaGeral = lazy(() =>
  import("../Pages/MapaGeral").then((module) => ({ default: module.MapaGeral }))
);
const Dashboard = lazy(() => import("../Pages/Dashboard").then(module => ({ default: module.Dashboard })));
const Admin = lazy(() =>
  import("../Pages/admin").then((module) => ({ default: module.Admin }))
);
const AdminElevatorias = lazy(() =>
  import("../Pages/admin/elevatoria").then((module) => ({
    default: module.AdminElevatorias,
  }))
);
const AdminUsuarios = lazy(() =>
  import("../Pages/admin/usuarios").then((module) => ({
    default: module.AdminUsuarios,
  }))
);
const Elevatorias = lazy(() =>
  import("../Pages/EEE/Elevatoria").then((module) => ({
    default: module.Elevatorias,
  }))
);

const CarregandoPagina = () => (
  <div
    role="status"
    aria-live="polite"
    style={{
      display: "grid",
      placeItems: "center",
      width: "100%",
      minHeight: "100dvh",
      color: "var(--cor-primaria)",
      background: "var(--branco)",
      fontWeight: 700,
    }}
  >
    Carregando...
  </div>
);

export const RoutersMain = () => {
  return (
    <Suspense fallback={<CarregandoPagina />}>
      <Routes>
        <Route element={<HomeProvider />}>
          <Route path="/" element={<Home />} />
          <Route path="/eee" element={<EEE />} />
          <Route path="/mapa-geral" element={<MapaGeral />} />
          <Route path="/eee/dashboard" element={<Dashboard />} />
          <Route path="/eee/dashboard/:stationId" element={<Dashboard />} />
          <Route
            path="/operacoes/esgotamento"
            element={<Navigate to="/eee" replace />}
          />
          <Route element={<AdminProvider />}>
            <Route path="/admin" element={<Admin />} />
            <Route
              path="/admin/lista/elevatorias"
              element={<AdminElevatorias />}
            />
            <Route path="/admin/lista/usuarios" element={<AdminUsuarios />} />
          </Route>
          <Route element={<ElevatoriaProvider />}>
            <Route path="/elevatoria/:codigo_estacao" element={<Elevatorias />} />
          </Route>
        </Route>
        <Route element={<LoginProvider />}>
          <Route path="/Login" element={<Login />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};
